const Instituciones = () => {
  return (
    <section className="w-[90%] mx-auto flex flex-col justify-center lg:items-center py-10 md:pt-24">
      {/* CODEDEH */}
      <div className="flex flex-col lg:flex-row lg:items-center gap-y-10 gap-x-14">
        <div className="flex flex-col lg:pl-20">
          <h2 className="text-[25px] lg:text-[35px] leading-10 mt-5 max-w-[500px] font-tommy-medium uppercase">CODEDEH</h2>
          <h3 className="text-[20px] lg:text-[25px] leading-8 mt-3 max-w-[500px] font-tommy-medium">Objetivos Generales</h3>
          <p className="text-base mt-2 font-tommy-light max-w-[600px]">Promover el desarrollo local a través de la infraestructura en el departamento.</p>
          <h3 className="text-[20px] lg:text-[25px] leading-8 mt-4 max-w-[500px] font-tommy-medium">Objetivos Específicos</h3>
          <p className="text-base mt-2 font-tommy-light max-w-[600px]">Transparencia en la ejecución de proyectos u obras que se ejecuten dentro de los techos presupuestarios de cada año.</p>
        </div>
        {/* IMAGEN CODEDEH */}
        <div className="flex justify-center w-full lg:w-[673px] lg:h-[328px] lg:pr-20">
          <img src="/images/mision2.jpeg" alt="SEGEPLAN" className="w-full h-full object-cover object-center" />
        </div>
      </div>
      {/* SEGEPLAN */}
      <div className="flex flex-col lg:flex-row lg:items-center gap-14 pt-10">
        <div className="flex flex-col lg:pr-20">
          <h2 className="text-[25px] lg:text-[35px] leading-10 mt-5 max-w-[500px] font-tommy-medium uppercase">SEGEPLAN</h2>
          <p className="text-base mt-4 font-tommy-light max-w-[600px]">Es el ente de planificación del Estado, que asesora y asiste técnicamente a las instituciones públicas y al Sistema de Consejos de Desarrollo, para vincular los procesos de políticas públicas, planificación y programación con el Plan y la Política Nacional de Desarrollo, así como para su debido seguimiento y evaluación.</p>
        </div>
        {/* IMAGEN SEGEPLAN */}
        <div className="flex justify-center w-full lg:w-[673px] lg:h-[328px] lg:-order-1 lg:pl-20">
          <img src="/images/segeplan.jpeg" alt="SEGEPLAN" className="w-full h-full object-contain object-center" />
        </div>
      </div>
    </section>
  );
}

export default Instituciones;